module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("1")])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("The Evolution of Petroleum Refining")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_c('b', [_vm._v("U")])]), _vm._v("ntil the advent of the "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-54"
    }
  }, [_vm._v("gasoline engine in the late nineteenth century, people used petroleum products only for what we now consider basic needs—lighting, heating, cooking, lubricating. When Colonel Edwin Drake drilled the first well to a depth of sixty-nine feet in 1859 in Titusville, PA, and initiated the oil era, his investors were thrilled. They saw the opportunity to compete with whale oil in the illumination market by providing a similar product, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-55"
    }
  }, [_vm._v("kerosene. ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-56"
    }
  }, [_vm._v("Gasoline and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-57"
    }
  }, [_vm._v("naphtha were mostly considered waste products, often allowed to “weather”— a euphemism for evaporation in open pits into the atmosphere—before the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-58"
    }
  }, [_vm._v("kerosene was recovered. Sometimes refiners just burned the lighter material or dumped it into nearby streams to get rid of it. It didn’t take long for refiners to recognize that the heavier parts of the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-59"
    }
  }, [_vm._v("crude oil could be used as ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-60"
    }
  }, [_vm._v("fuel oil for raising steam and heating buildings.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-60"
    }
  }, [_vm._v("For thirty years after the discovery of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-61"
    }
  }, [_vm._v("crude oil, refining consisted of separating these various products by batch processing, now viewed as a tedious way to separate liquids. Batch processing operations consisted essentially of a series of boilers where oil is heated and vaporized into a ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-62"
    }
  }, [_vm._v("condenser where the vapors are returned to the liquid state. Starting around 1900, refiners strung these vessels in series and used a so-called "), _c('i', [_vm._v("continuous batch process")]), _vm._v(", still a capital- and energy-intensive way to do separation (")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig_1_1"
    }
  }, [_vm._v("Figs. 1-1")]), _vm._v(" and "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig_1_2"
    }
  }, [_vm._v("1-2")]), _vm._v("). Fractional distillation, using the trayed columns now used worldwide, did not come into widespread use until the 1920s. This technique had been used for nearly a decade to distill alcohols. Translation to the refining industry came shortly after the Prohibition Act of 1920 as out-of-work technologists from the spirits industry brought their expertise and enthusiasm to refining research and development. The efficiency of separating "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-63"
    }
  }, [_vm._v("crude oil into its constituents increased by twenty-five percent.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-63"
    }
  }, [_vm._v("Early automobiles such as the famous Stanley brothers’ Stanley Steamer were steam-driven, often fueled by ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-64"
    }
  }, [_vm._v("kerosene. By 1890 inventor-entrepreneurs with the venerable names Karl Benz, Henry Ford, Ransom Olds, and Dave Buick, among others, were marketing their automotive eponyms with internal combustion engines that needed a light fuel, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-65"
    }
  }, [_vm._v("gasoline. That precipitated the most profound change ever to the profile and purpose of refining.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-65"
    }
  }, [_vm._v("By 1910, some 500,000 cars traveled U.S. roads, and the demand for ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-66"
    }
  }, [_vm._v("gasoline exceeded even the volumes that were formerly considered disposal streams.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig_1_1"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-66"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 1–1. Batch Processing Each batch is heated, driving off all the lower boiling temperature components. Then the remains, higher boiling temperature components, are drained, the vessel refilled, and the next batch is processed.",
      "src": "images/Fig_1-1_Batch_Process.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-66"
    }
  }, [_c('b', [_vm._v("Fig. 1–1. ")]), _vm._v("Batch Processing")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-66"
    }
  }, [_vm._v("Each batch is heated, driving off all the lower ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-67"
    }
  }, [_vm._v("boiling temperature components. Then the remains, higher ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-68"
    }
  }, [_vm._v("boiling temperature components, are drained, the vessel refilled, and the next batch is processed.")])])])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-68"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-68"
    }
  }, [_vm._v("Then, running more ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-69"
    }
  }, [_vm._v("crude oil to satisfy the growing ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-70"
    }
  }, [_vm._v("gasoline demand only created surpluses of the non-gasoline ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-71"
    }
  }, [_vm._v("fractions. Chemical engineers realized they could convert some of the heavier parts of the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-72"
    }
  }, [_vm._v("crude oil by cooking it until it cracked into lighter ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-73"
    }
  }, [_vm._v("fractions. Vladimir Shukov patented the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-74"
    }
  }, [_vm._v("thermal cracking process in Russia in 1891, but Amoco brought the first American ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-75"
    }
  }, [_vm._v("cracker on-stream in 1912 in Chicago. Their chief scientist, William Burton, took the victory lap for one of the most important breakthroughs in refining history, eclipsing poor Shukov. In any event, the timing was fortuitous because electricity was devastating the illumination market for ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-76"
    }
  }, [_vm._v("kerosene and the jet plane had not yet been invented.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-76"
    }
  }, [_vm._v("The chemists of General Motors, led by Charles Kettering, discovered in 1921 that adding small amounts of lead compounds (")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-77"
    }
  }, [_vm._v("tetraethyl lead or tetramethyl lead) to ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-78"
    }
  }, [_vm._v("gasoline significantly improved its ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-79"
    }
  }, [_vm._v("octane number. Thereafter, engine efficiency improved, but lead emissions increasingly fouled the environment until they were prohibited in the late 1970s.")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-79"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig_1_2"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 1–2. Batch Processing Facility Circa 1920, a distillation operation at a Shell refinery. Courtesy Shell.",
      "src": "images/Fig_1-2_Batch_Process_circa_1920.jpg"
    }
  })]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Fig. 1–2. ")]), _vm._v("Batch Processing Facility")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Circa 1920, a distillation operation at a Shell refinery. Courtesy Shell.")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-79"
    }
  }, [_vm._v("Catalysis was still an emerging science in 1936 when Eugene Houdry introduced the grandfather of all catalytic ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-80"
    }
  }, [_vm._v("crackers—a fixed bed design using a natural clay-like ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-81"
    }
  }, [_vm._v("catalyst that doubled the volume of quality ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-82"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-83"
    }
  }, [_vm._v("gasoline made from ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-84"
    }
  }, [_vm._v("cracking heavy feedstocks compared to thermal ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-85"
    }
  }, [_vm._v("cracking. The first fluidized bed ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-86"
    }
  }, [_vm._v("cat cracker, where the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-87"
    }
  }, [_vm._v("catalyst flows through the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-88"
    }
  }, [_vm._v("reactor along with the oil (the scheme used today), followed at Esso’s Baton Rouge refinery in 1940.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-88"
    }
  }, [_vm._v("Meanwhile, the auto industry continued to demand better quality ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-89"
    }
  }, [_vm._v("gasoline, and in 1949 the first catalytic ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-90"
    }
  }, [_vm._v("reformer using a ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-91"
    }
  }, [_vm._v("platinum ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-92"
    }
  }, [_vm._v("catalyst started up at, of all places, Old Dutch Refining Company in Muskegon, Michigan. This innovation improved the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-93"
    }
  }, [_vm._v("octane number of the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-94"
    }
  }, [_vm._v("naphtha already being blended into ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-95"
    }
  }, [_vm._v("gasoline and gave rise to Shell’s later advertisements for “Super Shell with Platformate.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-95"
    }
  }, [_vm._v("Hydroprocessing became increasingly important in the latter half of the twentieth century. That includes ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-96"
    }
  }, [_vm._v("hydrotreating to remove contaminants, a response to social demands to preserve the environment. ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-97"
    }
  }, [_vm._v("Hydrocracking had its origin in concerns about the burgeoning supplies of middle ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-98"
    }
  }, [_vm._v("distillates (home ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-99"
    }
  }, [_vm._v("heating oil, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-100"
    }
  }, [_vm._v("diesel fuel, and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-101"
    }
  }, [_vm._v("kerosene) manufactured as refiners struggled to meet growing ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-102"
    }
  }, [_vm._v("gasoline demands. ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-103"
    }
  }, [_vm._v("Hydrocracking, a process that could convert ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-104"
    }
  }, [_vm._v("distillates into ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-105"
    }
  }, [_vm._v("gasoline, lent a quick solution to the imbalance.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-105"
    }
  }, [_vm._v("As refiners tried to convert more ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-106"
    }
  }, [_vm._v("bottom of the barrel into lighter products, they grappled with the problem of rapid ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-107"
    }
  }, [_vm._v("coke (")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-108"
    }
  }, [_vm._v("carbon) build-up in their ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-109"
    }
  }, [_vm._v("thermal cracker process equipment. They finally solved the problem by speeding up the oil as it whisked through the process, delaying the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-110"
    }
  }, [_vm._v("coke formation until it could take place in a vessel where the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-111"
    }
  }, [_vm._v("coke could be harvested—the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-112"
    }
  }, [_vm._v("coke drum. Unabashedly, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("they called the process delayed ")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-113"
    }
  }, [_vm._v("coking. As environmental regulations and growing crude runs pushed down the relative value of the ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-114"
    }
  }, [_vm._v("bottom of the barrel, refiners built ever more delayed ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-115"
    }
  }, [_vm._v("cokers to reduce or even eliminate ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-116"
    }
  }, [_vm._v("residual fuel from their product offerings, replacing it with increased clean fuel volumes with only a modicum of ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-117"
    }
  }, [_vm._v("coke to be disposed.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-117"
    }
  }, [_vm._v("Why is the Evolution Important?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-117"
    }
  }, [_vm._v("Much of the technological change in the last sixty years has been driven by environmental concern, particularly the bad actors spewing from the tailpipes of cars— SO"), _c('sub', [_vm._v("x")]), _vm._v(", NO"), _c('sub', [_vm._v("x")]), _vm._v(", VOCs, and TOX—otherwise known as ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-118"
    }
  }, [_vm._v("sulfur oxides, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-119"
    }
  }, [_vm._v("nitrogen oxides, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-120"
    }
  }, [_vm._v("volatile organic (unburned) compounds, and toxins. Although these may sound like the children of circus workers, ever-tightening governmental regulations to reduce their presence caused refiners to continually tweak existing processes, especially with the introduction of new and improved ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-121"
    }
  }, [_vm._v("catalysts. Response to environmental mandates almost always undermines refining capabilities and costs money. (Otherwise the refiners would already have done it.) A succession of improved and new designer ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-122"
    }
  }, [_vm._v("catalysts has enabled most refiners to respond without the albatross of totally debilitating capital expenditure effectiveness.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-122"
    }
  }, [_vm._v("Holding aside the totally baffling chemistry of catalysis, evolution, not revolution, should be especially good news to the reader. It’s tough enough to understand the basic processes without having to worry about what’s becoming obsolete before you’ve even learned it.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-122"
    }
  }, [_vm._v("Today’s five basic refining processes have remained the same for a long time:")])]), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-122"
    }
  }, [_vm._v("- "), _c('b', [_vm._v("separation")]), _vm._v(", either by distillation, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-123"
    }
  }, [_vm._v("adsorption, or ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-124"
    }
  }, [_vm._v("absorption, where the molecules remain intact and no chemistry takes place")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-124"
    }
  }, [_vm._v("- ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-125"
    }
  }, [_c('b', [_vm._v("cracking")]), _vm._v(", using ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-126"
    }
  }, [_vm._v("catalysts with or without ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-127"
    }
  }, [_vm._v("hydrogen, breaking apart large molecules into smaller ones, as in ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-128"
    }
  }, [_vm._v("cat cracking, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-129"
    }
  }, [_vm._v("hydrocracking, and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-130"
    }
  }, [_vm._v("coking")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-130"
    }
  }, [_vm._v("- "), _c('b', [_vm._v("reshaping")]), _vm._v(", changing the configuration of individual molecules, as in ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-131"
    }
  }, [_vm._v("cat reforming and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-132"
    }
  }, [_vm._v("isomerization")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-132"
    }
  }, [_vm._v("- "), _c('b', [_vm._v("combining")]), _vm._v(", making larger molecules from smaller molecules so they can be used in ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-133"
    }
  }, [_vm._v("gasoline, as in ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-134"
    }
  }, [_vm._v("alkylation and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-135"
    }
  }, [_vm._v("polymerization")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-135"
    }
  }, [_vm._v("- "), _c('b', [_vm._v("treating")]), _vm._v(", using ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-136"
    }
  }, [_vm._v("catalysts and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-137"
    }
  }, [_vm._v("hydrogen and other substances to chemically remove contaminants.")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-137"
    }
  }, [_vm._v("You will have to keep reminding yourself as you go through the first half of this book that only the first process, separation, has "), _c('b', [_vm._v("no")]), _vm._v(" chemistry associated with it—the molecules going in are the same as the molecules coming out. They just end up in different buckets.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-137"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("The other four processes are all about chemical change. Some of them are substantial, as in ")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-138"
    }
  }, [_vm._v("cracking, reforming, and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-139"
    }
  }, [_vm._v("alkylation. One or more kinds of molecules go in, different molecules come out. Some processes have only minor change, as in treating, where contaminants like ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-140"
    }
  }, [_vm._v("sulfur are removed with only a few by-products generated in the process.")])])])])])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-140"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 75
// module chunks = 0